import AppQrCodeModal from './AppQrCodeModal';

export default AppQrCodeModal;
